// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2zaaH","sendOtp":"AuthorizeToLogin_sendOtp__2m7wU"};